/** @module */

/**
 * @enum {string}
 * @includevals
 */
export const userRoleTypes = {
    project: 'project',
    company: 'company',
};